import {AbsetzungenDto} from '@wba/modules/absetzungen/models/api/absetzungen.dto';
import {Observable} from 'rxjs';


export abstract class AbsetzungenService {
  abstract load(antragId): Observable<any>;

  abstract save(requestBody: AbsetzungenDto): Observable<any>;

  abstract delete(antragId, absetzungId): Observable<any>;
}
